import { TaxReportsPage } from './pages'

export const TaxReports = () => <TaxReportsPage />
